import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Tooltip, IconButton } from '@mui/material';

type props = {
    title?: string
}

const TooltipIcon = ({title = ""}: props) => {
  return (
    <Tooltip title={title}>
        <IconButton size='small'>
            <HelpOutlineIcon />
        </IconButton>
    </Tooltip>
  )
}

export default TooltipIcon